import { useState, useContext, createContext, PropsWithChildren } from "react";
import {
  IToastNotification,
  IToastMessage,
  DEFAULT_TOAST_DATA,
  TOAST_SCREEN_DURATION,
} from "./interfaces";

const ToastNotificationContext = createContext<IToastNotification>(DEFAULT_TOAST_DATA);

export const ToastNotificationContextProvider = ({ children }: PropsWithChildren) => {
  const [isShowing, setIsShowing] = useState<boolean>(false);
  const [message, setMessage] = useState<IToastMessage>({ text: "", title: "" });
  const [type, setType] = useState<string>("success");

  const setToastData = (currMessage: IToastMessage, currType: string) => {
    setMessage(currMessage);
    setType(currType);
    setIsShowing(true);
    setTimeout(() => setIsShowing(false), TOAST_SCREEN_DURATION);
  };

  return (
    <ToastNotificationContext.Provider value={{ isShowing, message, type, setToastData }}>
      {children}
    </ToastNotificationContext.Provider>
  );
};

export const useToastNotificationContext = () => {
  const context = useContext(ToastNotificationContext);
  return context;
};
